const { serialize, join } = require('@pepita/querystring');

let isLoaded = false;

if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
}

const loadGTM = function(config) {
    if (typeof window === 'undefined') return Promise.resolve();

    return new Promise((resolve) => {
        if (isLoaded) resolve(undefined);
        else {
            if (config && config.id) {
                window.dataLayer.push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js',
                });

                let firtsScriptElement = document.getElementsByTagName(
                    'script'
                )[0];
                let tagManagerScriptElement = document.createElement('script');
                tagManagerScriptElement.async = true;
                tagManagerScriptElement.src = join(
                    'https://www.googletagmanager.com/gtm.js',
                    serialize({
                        id: config.id,
                        gtm_auth: config.auth,
                        gtm_preview: config.preview,
                    })
                );
                firtsScriptElement.parentNode.insertBefore(
                    tagManagerScriptElement,
                    firtsScriptElement
                );

                tagManagerScriptElement.onload = () => {
                    resolve(undefined);
                };

                isLoaded = true;
            }
        }
    });
};

const delay =
    typeof requestIdleCallback !== 'undefined'
        ? requestIdleCallback
        : (fn) => requestAnimationFrame(fn);

const sendDataToGTM = (data) => {
    if (typeof window !== 'undefined') {
        delay(() => {
            requestAnimationFrame(() => {
                window.dataLayer.push(data);
            });
        });
    }
};

exports.loadGTM = loadGTM;
exports.sendDataToGTM = sendDataToGTM;
